import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import theme, { shadows } from "@/theme";
import HealthMeasurementGauge from "@/features/MyHealth/components/HealthMeasurementGauge";
import {
  getHealthMeasurementValueRange,
  HealthMeasurementDataValueRange,
  HealthMeasurementQuestionType,
} from "@/services/core-api-adapter";
import { HealthMeasurementIdentifier } from "@/store";
import { getHealthMeasurementValueRangeColors } from "@/theme";

function replaceValuesWithColours(
  valueRange: HealthMeasurementDataValueRange[],
  key: HealthMeasurementQuestionType
) {
  const colorMap = getHealthMeasurementValueRangeColors() as Record<
    string,
    Record<string, string>
  >;
  return valueRange.map((item) => {
    return {
      ...item,
      color: colorMap[key]?.[item.healthRiskIndicator],
    };
  });
}

export default function BMIGauge({ value }: { value: number }) {
  const { t } = useTranslation();
  const valueRangeBodyMassIndex = replaceValuesWithColours(
    getHealthMeasurementValueRange("BodyMassIndex"),
    "BodyMassIndex"
  );

  return (
    <Box
      sx={{
        width: "100%",
        background: theme.palette.background.paper,
        borderRadius: 2.5,
        padding: 2,
        boxShadow: shadows.light,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography
        variant="h4"
        sx={{ fontSize: 16, paddingBottom: 2, textAlign: "center" }}
      >
        {t("HealthHistory.bmi.gauge.title")}
      </Typography>
      <HealthMeasurementGauge
        healthMeasurementIdentifier={HealthMeasurementIdentifier.BodyMassIndex}
        value={value}
        valueRange={valueRangeBodyMassIndex}
        numberOfTicks={41}
      />
    </Box>
  );
}
